<mat-stepper [orientation]="isHandset ? 'vertical' : 'horizontal'" #stepper>

  <!-- STEP 1: Podaci o programu/projektu -->
  <mat-step label="1. Podaci o programu/projektu">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">1. Podaci o programu/projektu</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (generalProjectFieldValues.length > 0) {
          @for (field of generalProjectFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span>
                    @switch (field.type) {
                      @case ('currency') {
                        {{ field.value | currency:'EUR' }}
                      }
                      @case ('date') {
                        {{ field.value | date:'d.M.yyyy.' }}
                      }
                      @case ('bool') {
                        {{ field.value ? 'Da' : 'Ne' }}
                      }
                      @default {
                        {{ field.value }}
                      }
                    }
                  </span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- STEP 2: Kontaktni podaci -->
  <mat-step label="1.1 Kontaktni podaci">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">1.1 Kontaktni podaci</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (contactFieldValues.length > 0) {
          @for (field of contactFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span>
                    @switch (field.type) {
                      @case ('currency') {
                        {{ field.value | currency:'EUR' }}
                      }
                      @case ('date') {
                        {{ field.value | date:'d.M.yyyy.' }}
                      }
                      @case ('bool') {
                        {{ field.value ? 'Da' : 'Ne' }}
                      }
                      @default {
                        {{ field.value }}
                      }
                    }
                  </span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- STEP 3: Postignuća i rezultati -->
  <mat-step label="2. Postignuća i rezultati">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">2. Postignuća i rezultati</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (achievementsFieldValues.length > 0) {
          @for (field of achievementsFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span>
                    @switch (field.type) {
                      @case ('currency') {
                        {{ field.value | currency:'EUR' }}
                      }
                      @case ('date') {
                        {{ field.value | date:'d.M.yyyy.' }}
                      }
                      @case ('bool') {
                        {{ field.value ? 'Da' : 'Ne' }}
                      }
                      @default {
                        {{ field.value }}
                      }
                    }
                  </span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- STEP 4: Provoditelji programa/projekta -->
  <mat-step label="3. Provoditelji programa/projekta">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">3. Provoditelji programa/projekta</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (executorsFieldValues.length > 0) {
          @for (field of executorsFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span>
                    @switch (field.type) {
                      @case ('currency') {
                        {{ field.value | currency:'EUR' }}
                      }
                      @case ('date') {
                        {{ field.value | date:'d.M.yyyy.' }}
                      }
                      @case ('bool') {
                        {{ field.value ? 'Da' : 'Ne' }}
                      }
                      @default {
                        {{ field.value }}
                      }
                    }
                  </span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- STEP 5: Proračun programa/projekta -->
  <mat-step label="4. Proračun programa/projekta">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">4. Proračun programa/projekta</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (budgetFieldValues.length > 0) {
          @for (field of budgetFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span>
                    @switch (field.type) {
                      @case ('currency') {
                        {{ field.value | currency:'EUR' }}
                      }
                      @case ('date') {
                        {{ field.value | date:'d.M.yyyy.' }}
                      }
                      @case ('bool') {
                        {{ field.value ? 'Da' : 'Ne' }}
                      }
                      @default {
                        {{ field.value }}
                      }
                    }
                  </span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- STEP 6: Ostali podaci -->
  <mat-step label="5. Ostali podaci">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">5. Ostali podaci</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (additionalFieldValues.length > 0) {
          @for (field of additionalFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined && field.value !== '') {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span>
                    @switch (field.type) {
                      @case ('currency') {
                        {{ field.value | currency:'EUR' }}
                      }
                      @case ('date') {
                        {{ field.value | date:'d.M.yyyy.' }}
                      }
                      @case ('bool') {
                        {{ field.value ? 'Da' : 'Ne' }}
                      }
                      @default {
                        {{ field.value }}
                      }
                    }
                  </span>
                </p>
              }
            </div>
          }
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- STEP 7: Aktivnosti -->
  <mat-step label="6. Aktivnosti">
    @if (getActivities.length > 0) {
      @for (activity of getActivities; track activity; let i = $index) {
        <div class="mb-25">
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>
              <p><strong>Naziv aktivnosti:</strong> {{ activity.name }}</p>
              <p><strong>Opis aktivnosti:</strong> {{ activity.description }}</p>
              <p><strong>Rezultati:</strong> {{ activity.results }}</p>
              <p><strong>Datum početka:</strong> {{ activity.startDate | date:'d.M.yyyy.' }}</p>
              <p><strong>Datum završetka:</strong> {{ activity.endDate | date:'d.M.yyyy.' }}</p>
            </mat-card-content>
          </mat-card>
        </div>
      }
    } @else {
      <p>Nema zabilježenih aktivnosti.</p>
    }
  </mat-step>

  <!-- STEP 8: Prilozi izvještaju (dokumenti) -->
  <mat-step label="7. Prilozi izvještaju">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">7. Prilozi izvještaju</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (reportFiles && reportFiles.length > 0) {
          <p><strong>Priloženi dokumenti ({{ reportFiles.length }}):</strong></p>
          <ul>
            @for (file of reportFiles; track file) {
              <li>
                <a (click)="downloadFile(file)" class="download-link">
                  {{ file.name }}
                </a>
              </li>
            }
          </ul>
        } @else {
          <p>Nema priloženih dokumenata.</p>
        }
      </mat-card-content>
    </mat-card>
  </mat-step>

</mat-stepper>